import { API, Invoice, Order } from '@typings';
import { timer } from 'rxjs';
import { filter, mergeMap, takeWhile } from 'rxjs/operators';

import { paymentsRepository, selectionRepository } from '../services';

import { getIsOrderClosed, getIsOrderSplit } from './Orders';

const POLLING_INTERVAL = 3000;
const POLLING_ATTEMPTS = 20;

const shouldPollInvoice = (response: API.SuccessResponse<Invoice.PaymentResult> | API.FailedResponse<unknown>, index: number) => {
  const isSuccessResponse = response.status === 'SUCCESS';
  const isTimeout = index === POLLING_ATTEMPTS;

  return (!isSuccessResponse || response.data.status !== 'PAID') && !isTimeout;
};

export const invoicePaymentResultLongPolling = (identifiers: Invoice.InvoiceIdentifiers) =>
  timer(0, POLLING_INTERVAL).pipe(
    mergeMap(async () => paymentsRepository.getInvoicePaymentResult(identifiers)),
    takeWhile(shouldPollInvoice, true),
    filter((response, index) => !shouldPollInvoice(response, index)),
  );

const shouldPollOrder = (response: API.SuccessResponse<Order.Single | Order.Split> | API.FailedResponse<unknown>, index: number) => {
  const isSuccessResponse = response.status === 'SUCCESS';
  const isTimeout = index === POLLING_ATTEMPTS;
  const isOrderCreated = isSuccessResponse && (getIsOrderSplit(response.data) || getIsOrderClosed(response.data.order));

  return !isOrderCreated && !isTimeout;
};

export const orderPaymentResultLongPolling = (orderId: Order.Id) =>
  timer(0, POLLING_INTERVAL).pipe(
    mergeMap(async () => selectionRepository.loadOrder(orderId)),
    takeWhile(shouldPollOrder, true),
    filter((response, index) => !shouldPollOrder(response, index)),
  );
